<div class="modal-container">
    <!-- Modal Header -->
    <div class="modal-header">
        <h2 class="modal-title">
            <mat-icon>edit</mat-icon>
            <span *ngIf="dados['id'] && tipo != 3">
                {{ 'telaLista.editarResgistro' | translate }}
            </span>
            <span *ngIf="!dados['id']">
                {{ 'telaPadrao.incluirResgistro' | translate }}
            </span>
            <span *ngIf="dados['id'] && tipo == 3">
                {{ 'telaLista.duplicarRegistro' | translate }}
            </span>
        </h2>
        <button class="close-button" (click)="fechar()" mat-icon-button *ngIf="!cadastroIntegracao">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
        <!-- Filter Section -->
        <div class="filter-section">
            <h3 class="filter-title">
                <mat-icon>info</mat-icon>
                {{ 'telaPadrao.informacoesRegistro' | translate }}
            </h3>
            <div class="filter-controls">
                <div class="filter-field">
                    <label>{{'telaPadrao.campoIdentificadores' | translate}}:</label>
                    <div class="identifier-display">
                        <span>{{descricaoIdentificador}}</span>
                    </div>
                </div>
                <div class="filter-field" *ngIf="!cadastroIntegracao">
                    <label>{{'telaElasticSearch.filtrarCampo' | translate}}:</label>
                    <div class="search-input-wrapper">
                        <input type="text" 
                               [(ngModel)]="filtro" 
                               class="form-control"
                               placeholder="{{'telaElasticSearch.filtrarCampo' | translate}}" />
                        <mat-icon class="search-icon">search</mat-icon>
                    </div>
                </div>
                <div class="filter-field" *ngIf="!cadastroIntegracao">
                    <label>{{'telaElasticSearch.filtrarObrigatoriedade' | translate}}:</label>
                    <mat-button-toggle-group [(ngModel)]="filtroObrigatoriedade" class="toggle-obrigatoriedade">
                        <mat-button-toggle value="todos">
                            {{'telaElasticSearch.todos' | translate}}
                        </mat-button-toggle>
                        <mat-button-toggle value="obrigatorios">
                            {{'telaElasticSearch.obrigatorios' | translate}}
                        </mat-button-toggle>
                        <mat-button-toggle value="naoObrigatorios">
                            {{'telaElasticSearch.naoObrigatorios' | translate}}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="filter-field" *ngIf="!cadastroIntegracao">
                    <label>{{'telaPadrao.addValoresRandomicos' | translate}}:</label>
                    <button mat-icon-button 
                            class="add-value-button" 
                            color="primary" 
                            [matTooltip]="'telaPadrao.addValoresRandomicos' | translate" 
                            (click)="addValorPadrao()">
                        <mat-icon>note_add</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- Form Fields Section -->
        <div class="form-section" *ngIf="dados">
            <div class="form-wrapper">
                <div class="boxCadastro">
                    <div class="row form-group">
                        <div class="col-md-3" *ngFor="let campo of listaCamposEditaveis">
                            <app-elasticsearch-edit-item 
                                (alterarDado)="alterarValor($event)" 
                                [campo]="campo.nome" 
                                [identificadores]="obterCamposIdentificadores()"
                                [valor]="dados[getPropriedade(campo.nome)]" 
                                [tipoDado]="campo.listaCampoTipoId.toString()">
                            </app-elasticsearch-edit-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
        <div class="footer-left">
            <button (click)="fechar()" *ngIf="!cadastroIntegracao" mat-raised-button>
                <mat-icon>close</mat-icon>
                {{'telaPadrao.fechar' | translate}}
            </button>
        </div>
        <div class="footer-right">
            <button (click)="salvar()" [disabled]="desabilitaSalvar()" mat-raised-button color="primary">
                <mat-icon>save</mat-icon>
                {{'telaPadrao.salvar' | translate}}
            </button>
        </div>
    </div>
</div>